export default {};

// @ipld/car
export const Readable = {};
